import _ from 'lodash';

export const postPath = (slug: string) => `/blog/${slug}/`;
export const blogCategoryPath = (category: string) =>
  `/blog/categories/${_.kebabCase(category)}/`;
export const libraryCategoryPath = (slug: string) =>
  `/library/categories/${slug}/`;
export const libraryCollectionPath = (slug: string) => `/library/${slug}/`;
export const libraryPostPath = (slug: string) => `/library/templates/${slug}/`;
